import React from "react";

import type { SxProps } from "@mui/material";
import Typography from "@mui/material/Typography";

import ColorPicker, {
  ColorPickerProps,
} from "@app/analytics/components/ColorPicker";
import {
  getTagFontColorFromColor,
  TAG_COLORS,
} from "@app/analytics/components/Tag/utils";
import type { Tag } from "@app/common/types";

import { SelectableTagContainer } from "./styles";

interface SelectableTagProps {
  color: Tag["color"];
  isNew?: boolean;
  kind?: Tag["kind"];
  name: Tag["name"];
  onClick?: () => void;
  onColorChange?: ColorPickerProps["onChange"];
  sx?: SxProps;
}

const SelectableTag = ({
  isNew = false,
  color,
  kind = "custom",
  name,
  onClick,
  onColorChange,
  sx,
}: SelectableTagProps) => {
  return (
    <SelectableTagContainer onClick={onClick} sx={sx}>
      <Typography
        variant="labelMed"
        className="selectable-tag__label"
        title={name}
      >
        {name}
        {isNew ? " (new)" : ""}
      </Typography>
      <ColorPicker
        colors={TAG_COLORS}
        onChange={kind === "custom" ? onColorChange : undefined}
        selected={{
          backgroundColor: color,
          color: getTagFontColorFromColor(color),
        }}
      />
    </SelectableTagContainer>
  );
};

export default SelectableTag;
